import React from 'react'
import Wizard from '../../mailTemplate/src/components/atomic/pages/Wizard'
import CampaignPreparation from '../../mailTemplate/src/components/atomic/pages/CampaignPreparation'
import ContactSelection from '../../mailTemplate/src/components/atomic/pages/ContactSelection'
import CampaignReview from '../../mailTemplate/src/components/atomic/pages/CampaignReview'
import { useCampaignStatus } from '../../store/globalStore'

const CampaignFirms = ({ campaign, onCampaignUpdate }) => {
  const globalStatus = useCampaignStatus(campaign?.id)

  const status = globalStatus || campaign?.status

  if (status === 'PREPARING' || status === 'READY_TO_SELECT') {
    return (
      <CampaignPreparation
        campaign={campaign}
        onCampaignUpdate={onCampaignUpdate}
        showProgressBar={status === 'PREPARING'}
      />
    )
  }

  if (status === 'CONTACTS_SEARCHING' || status === 'CONTACTS_FOUND') {
    return (
      <ContactSelection
        campaign={campaign}
        onCampaignUpdate={onCampaignUpdate}
        isSearching={status === 'CONTACTS_SEARCHING'}
      />
    )
  }

  if (status === 'GENERATING' || status === 'READY_TO_MAIL' || status === 'MAILING') {
    return (
      <CampaignReview
        campaign={campaign}
        onCampaignUpdate={onCampaignUpdate}
        showProgressBar={status === 'GENERATING'}
      />
    )
  }

  if (status === 'FAILED') {
    return null
  }

  return <Wizard onCampaignUpdate={onCampaignUpdate} />
}

export default CampaignFirms
